const languageSpecificSettingOverrides: {[key: string]: any} = {
    "en-US": {
        "textConstants.lessLinkText": "Less >>",
        //"textConstants.moreLinkText": "More",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "There was an error processing the last request. Please try again later.",
        "textConstants.launchPointText": "Need Help?",
        "textConstants.inputboxPlaceholderText": "Please type your text here",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Intelligent Virtual Assistant",
        "textConstants.userDisplayName": "You: ",
        "textConstants.sendButtonTitleText": "Submit your question.",
        "textConstants.minimizeWindowTitleText": "Close chat window",
        "textConstants.pleaseWaitText": "Please wait...",
        "textConstants.pendingPlaceholder": "Please wait...",
        "textConstants.dataCollectionFormatError": "Please enter information in the correct format.",
        "textConstants.dataCollectionRequiredError" : "Please enter all required information.",
        "textConstants.dataCollectionRequiredTextDesc": "Required information",
        "textConstants.linkFoldTitleText": "View more links",
        "textConstants.viewPageLinkText": "View Page",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Your session will expire in two minutes. Do you wish to continue your current session?",
        "textConstants.timeoutWarningYesTitle": "Yes",
        "textConstants.skipToContentLinkText": "Skip to End of Chat",
        "textConstants.inputboxErrorText": "Please type a message to continue.",
        "textConstants.submitContent": "Submit",

        "endSession.notificationMessage": "Your session has ended",

        "accessibility.aria.inputBox": "Please type your text here",
        "accessibility.aria.personaLabel": "Intelligent Virtual Assistant",
        "accessibility.aria.conversationHistoryLabel": "Conversation History",
        "accessibility.aria.toolbar": "Toolbar",
        "accessibility.aria.feedbackOverlay": "Feedback overlay",
        "accessibility.aria.minimize": "Minimize",
        "accessibility.StepOutTitle": "This indicates a link to an external site that may not follow the same accessibility policies.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "End Live Chat",
        "livechat.textConstants.endChatLinkToolTip": "Click to end Live Chat",
        // title bar text
        "livechat.textConstants.bannerText": "Chat With Us",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Connecting to",
        "livechat.textConstants.chatBannerConnectingSecondary": "Live Chat",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Connected to",
        "livechat.textConstants.chatBannerConnectedSecondary": "Live Chat Operator: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Returning to",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "Customer Ended Live Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Returning to",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "Operator Ended Live Chat",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "Customer Ended Live Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Live Chat Ended",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "System Ended Live Chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "System Ended Live Chat",
        "livechat.textConstants.errorResponse": "Uh oh, looks like we were unable to process your request. Please try again.",
        "livechat.textConstants.pendingPlaceholder": "Please wait...",
        "livechat.textConstants.typingNotificationText": "{0} typing...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "Are you sure you want to end your live chat session?",
        "textConstants.endChatWarningYesTitle" : "Yes",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} said:",
        "livechat.textConstants.sentMessageReceiveText": "Message received, operator responding shortly...",
        "livechat.textConstants.inputPlaceholderText": "Please wait...",
        "xPosition": 469,
        "yPosition": 519,

        // Inline Survey only supported in English
        "inlineSurveyTitle": "Was this helpful?",
        "surveyCancelTitle": "Cancel",
        "surveyCloseTitle": "Close",
        "surveyFreeformAriaLabel": "Feedback input",
        "surveyFreeformTextTitle": "Survey Comment Box",
        "surveyQuestionNoTitle": "Survey Reason No Button",
        "surveyQuestionYesTitle": "Survey Reason Yes Button",
        "surveyRadioButtonsTitle": "Survey Reasons",
        "surveySubmitTitle": "Submit",
    },
    "en-CA": {
        "textConstants.lessLinkText": "Less >>",
        //"textConstants.moreLinkText": "More",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "There was an error processing the last request. Please try again later.",
        "textConstants.launchPointText": "Need Help?",
        "textConstants.inputboxPlaceholderText": "Please type your text here",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Intelligent Virtual Assistant",
        "textConstants.userDisplayName": "You: ",
        "textConstants.sendButtonTitleText": "Submit your question.",
        "textConstants.minimizeWindowTitleText": "Close chat window",
        "textConstants.pleaseWaitText": "Please wait...",
        "textConstants.pendingPlaceholder": "Please wait...",
        "textConstants.dataCollectionFormatError": "Please enter information in the correct format.",
        "textConstants.dataCollectionRequiredError" : "Please enter all required information.",
        "textConstants.dataCollectionRequiredTextDesc": "Required information",
        "textConstants.linkFoldTitleText": "View more links",
        "textConstants.viewPageLinkText": "View Page",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Your session will expire in two minutes. Do you wish to continue your current session?",
        "textConstants.timeoutWarningYesTitle": "Yes",
        "textConstants.skipToContentLinkText": "Skip to End of Chat",
        "textConstants.inputboxErrorText": "Please type a message to continue.",
        "textConstants.submitContent": "Submit",

        "endSession.notificationMessage": "Your session has ended",

        "accessibility.aria.inputBox": "Please type your text here",
        "accessibility.aria.personaLabel": "Intelligent Virtual Assistant",
        "accessibility.aria.conversationHistoryLabel": "Conversation History",
        "accessibility.aria.toolbar": "Toolbar",
        "accessibility.aria.feedbackOverlay": "Feedback overlay",
        "accessibility.aria.minimize": "Minimize",
        "accessibility.StepOutTitle": "This indicates a link to an external site that may not follow the same accessibility policies.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "End Live Chat",
        "livechat.textConstants.endChatLinkToolTip": "Click to end Live Chat",
        // title bar text
        "livechat.textConstants.bannerText": "Chat With Us",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Connecting to",
        "livechat.textConstants.chatBannerConnectingSecondary": "Live Chat",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Connected to",
        "livechat.textConstants.chatBannerConnectedSecondary": "Live Chat Operator: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Returning to",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "Customer Ended Live Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Returning to",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "Operator Ended Live Chat",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "Customer Ended Live Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Live Chat Ended",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "System Ended Live Chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Returning to",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Intelligent Virtual Assistant",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "System Ended Live Chat",
        "livechat.textConstants.errorResponse": "Uh oh, looks like we were unable to process your request. Please try again.",
        "livechat.textConstants.pendingPlaceholder": "Please wait...",
        "livechat.textConstants.typingNotificationText": "{0} typing...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "Are you sure you want to end your live chat session?",
        "textConstants.endChatWarningYesTitle" : "Yes",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} said:",
        "livechat.textConstants.sentMessageReceiveText": "Message received, operator responding shortly...",
        "livechat.textConstants.inputPlaceholderText": "Please wait...",
        "xPosition": 469,
        "yPosition": 519,
        
        // Inline Survey only supported in English
        "inlineSurveyTitle": "Was this helpful?",
        "surveyCancelTitle": "Cancel",
        "surveyCloseTitle": "Close",
        "surveyFreeformAriaLabel": "Feedback input",
        "surveyFreeformTextTitle": "Survey Comment Box",
        "surveyQuestionNoTitle": "Survey Reason No Button",
        "surveyQuestionYesTitle": "Survey Reason Yes Button",
        "surveyRadioButtonsTitle": "Survey Reasons",
        "surveySubmitTitle": "Submit",
    },
    "es-ES": {
        "textConstants.lessLinkText": "Menos >>",
        //"textConstants.moreLinkText": "Más",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Hubo un error al procesar su última petición. Por favor intente más tarde.",
        "textConstants.launchPointText": "¿Necesita ayuda?",
        "textConstants.inputboxPlaceholderText": "Escriba el texto aquí",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Asistente virtual inteligente",
        "textConstants.userDisplayName": "Usted: ",
        "textConstants.sendButtonTitleText": "Enviar su pregunta",
        "textConstants.minimizeWindowTitleText": "Cerrar la ventana",
        "textConstants.pleaseWaitText": "Por favor espere…",
        "textConstants.pendingPlaceholder": "Por favor espere…",
        "textConstants.dataCollectionFormatError": "Por favor ingrese su información en el formato correcto.",
        "textConstants.dataCollectionRequiredError" : "Por favor ingrese toda la información obligatoria.",
        "textConstants.dataCollectionRequiredTextDesc": "Información obligatoria",
        "textConstants.linkFoldTitleText": "Ver más enlaces",
        "textConstants.viewPageLinkText": "Ver página",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Su sesión expirará en dos minutos. ¿Desea continuar con su sesión actual?",
        "textConstants.timeoutWarningYesTitle": "Sí",
        "textConstants.skipToContentLinkText": "Saltar al final del chat",
        "textConstants.inputboxErrorText": "Escriba un mensaje para continuar.",
        "textConstants.submitContent": "Enviar",

        "endSession.notificationMessage": "Su sesión finalizó.",

        "accessibility.aria.inputBox": "Pregunta entrada",
        "accessibility.aria.personaLabel": "Asistente Virtual e Inteligente",
        "accessibility.aria.conversationHistoryLabel": "Historial de la conversación",
        "accessibility.aria.toolbar": "Barra de herramientas",
        "accessibility.aria.feedbackOverlay": "Revestimiento de retroalimentación",
        "accessibility.aria.minimize": "Minimizar",
        "accessibility.StepOutTitle": "Esto indica un enlace a un sitio externo que puede no seguir las misma políticas de accesibilidad.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Desconectar chat en vivo",
        "livechat.textConstants.endChatLinkToolTip": "Seleccione para desconectar el chat en vivo",
        // title bar text
        "livechat.textConstants.bannerText": "Charle con nosotros",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Conectando al",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en vivo",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Conectado a la",
        "livechat.textConstants.chatBannerConnectedSecondary": "Operadora del chat en vivo: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "El cliente desconectó el chat en vivo",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "El operador desconectó el chat en vivo",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "El cliente ha finalizado el chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Chat en vivo finalizado",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.errorResponse": "Vaya, parece que no pudimos procesar su solicitud. Inténtelo de nuevo.",
        "livechat.textConstants.pendingPlaceholder": "Por favor espere…",
        "livechat.textConstants.typingNotificationText": "{0} escribiendo...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "¿Está seguro de que desea finalizar su sesión de chat?",
        "textConstants.endChatWarningYesTitle" : "Sí",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} dijo:",
        "livechat.textConstants.sentMessageReceiveText": "Su mensaje fue recibido, el operador le responderá en un momento...",
        "livechat.textConstants.inputPlaceholderText": "Por favor espere…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "fr-FR": {
        "textConstants.lessLinkText": "Moins >>",
       // "textConstants.moreLinkText": "Plus",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Une erreur est survenue lors du traitement de la dernière demande. Veuillez réessayer plus tard.",
        "textConstants.launchPointText": "Vous avez besoin d’aide ?",
        "textConstants.inputboxPlaceholderText": "Veuillez taper votre texte ici",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Assistant virtuel intelligent",
        "textConstants.userDisplayName": "Vous : ",
        "textConstants.sendButtonTitleText": "Envoyez votre question.",
        "textConstants.minimizeWindowTitleText": "Fermer la fenêtre de chat",
        "textConstants.pleaseWaitText": "Veuillez patienter…",
        "textConstants.pendingPlaceholder": "Veuillez patienter…",
        "textConstants.dataCollectionFormatError": "Veuillez entrer les renseignements dans le format adéquat.",
        "textConstants.dataCollectionRequiredError" : "Veuillez entrer tous les renseignements requis",
        "textConstants.dataCollectionRequiredTextDesc": "Renseignements requis",
        "textConstants.linkFoldTitleText": "Voir plus de liens",
        "textConstants.viewPageLinkText": "Voir la page",
        "textConstants.timeoutWarningNoTitle": "Non",
        "textConstants.timeoutWarningText": "Votre session expirera fin dans deux minutes. Souhaitez-vous poursuivre votre session actuelle?",
        "textConstants.timeoutWarningYesTitle": "Oui",
        "textConstants.skipToContentLinkText": "Passer à la fin du clavardage",
        "textConstants.inputboxErrorText": "Veuillez taper un message pour continuer.",
        "textConstants.submitContent": "Envoyer",

        "endSession.notificationMessage": "Votre séance est terminée.",

        "accessibility.aria.inputBox": "Question entrée",
        "accessibility.aria.personaLabel": "Assistante virtuelle intelligente",
        "accessibility.aria.conversationHistoryLabel": "Historique de la conversation",
        "accessibility.aria.toolbar": "Barre d’outils",
        "accessibility.aria.feedbackOverlay": "Fenêtre de feed-back superposée",
        "accessibility.aria.minimize": "Réduire",
        "accessibility.StepOutTitle": "Cela indique qu’un lien mène à un site externe qui pourrait ne pas suivre les mêmes politiques d’accessibilité.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Mettre fin au chat en direct",
        "livechat.textConstants.endChatLinkToolTip": "Cliquez pour mettre fin au chat en direct",
        // title bar text
        "livechat.textConstants.bannerText": "Discutez avec nous",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Connexion en cours au",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en direct",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Connecté à l’",
        "livechat.textConstants.chatBannerConnectedSecondary": "Opérateur de chat en direct : {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Retour à",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "Le client a mis fin au chat en direct",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Retour à",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "L’opérateur a mis fin au chat en direct",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "Le client a mis fin à la discussion par Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Fin de la séance de clavardage en direct",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "Le système a mis fin à la discussion par Chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "Le système a mis fin à la discussion par Chat",
        "livechat.textConstants.errorResponse": "Il semble que nous n'ayons pas pu traiter votre demande. Veuillez réessayer.",
        "livechat.textConstants.pendingPlaceholder": "Veuillez patienter…",
        "livechat.textConstants.typingNotificationText": "{0} Est en train d’écrire",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "Êtes-vous sûr de vouloir terminer votre session de Chat?",
        "textConstants.endChatWarningYesTitle" : "Oui",
        "textConstants.endChatWarningNoTitle" : "Non",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} a dit :",
        "livechat.textConstants.sentMessageReceiveText": "Message reçu, l’opérateur répond sous peu...",
        "livechat.textConstants.inputPlaceholderText": "Veuillez patienter…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "es-US": {
        "textConstants.lessLinkText": "Menos >>",
        //"textConstants.moreLinkText": "Más",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Hubo un error al procesar su última petición. Por favor intente más tarde.",
        "textConstants.launchPointText": "¿Necesita ayuda?",
        "textConstants.inputboxPlaceholderText": "Escriba el texto aquí",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Asistente virtual inteligente",
        "textConstants.userDisplayName": "Usted: ",
        "textConstants.sendButtonTitleText": "Enviar su pregunta",
        "textConstants.minimizeWindowTitleText": "Cerrar la ventana",
        "textConstants.pleaseWaitText": "Por favor espere…",
        "textConstants.pendingPlaceholder": "Por favor espere…",
        "textConstants.dataCollectionFormatError": "Por favor ingrese su información en el formato correcto.",
        "textConstants.dataCollectionRequiredError" : "Por favor ingrese toda la información obligatoria.",
        "textConstants.dataCollectionRequiredTextDesc": "Información obligatoria",
        "textConstants.linkFoldTitleText": "Ver más enlaces",
        "textConstants.viewPageLinkText": "Ver página",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Su sesión expirará en dos minutos. ¿Desea continuar con su sesión actual?",
        "textConstants.timeoutWarningYesTitle": "Sí",
        "textConstants.skipToContentLinkText": "Saltar al final del chat",
        "textConstants.inputboxErrorText": "Escriba un mensaje para continuar.",
        "textConstants.submitContent": "Enviar",

        "endSession.notificationMessage": "Su sesión finalizó.",

        "accessibility.aria.inputBox": "Pregunta entrada",
        "accessibility.aria.personaLabel": "Asistente Virtual e Inteligente",
        "accessibility.aria.conversationHistoryLabel": "Historial de la conversación",
        "accessibility.aria.toolbar": "Barra de herramientas",
        "accessibility.aria.feedbackOverlay": "Revestimiento de retroalimentación",
        "accessibility.aria.minimize": "Minimizar",
        "accessibility.StepOutTitle": "Esto indica un enlace a un sitio externo que puede no seguir las misma políticas de accesibilidad.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Desconectar chat en vivo",
        "livechat.textConstants.endChatLinkToolTip": "Seleccione para desconectar el chat en vivo",
        // title bar text
        "livechat.textConstants.bannerText": "Charle con nosotros",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Conectando al",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en vivo",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Conectado a la",
        "livechat.textConstants.chatBannerConnectedSecondary": "Operadora del chat en vivo: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "El cliente desconectó el chat en vivo",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "El operador desconectó el chat en vivo",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "El cliente ha finalizado el chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Chat en vivo finalizado",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.errorResponse": "Vaya, parece que no pudimos procesar su solicitud. Inténtelo de nuevo.",
        "livechat.textConstants.pendingPlaceholder": "Por favor espere…",
        "livechat.textConstants.typingNotificationText": "{0} escribiendo...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "¿Está seguro de que desea finalizar su sesión de chat?",
        "textConstants.endChatWarningYesTitle" : "Sí",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} dijo:",
        "livechat.textConstants.sentMessageReceiveText": "Su mensaje fue recibido, el operador le responderá en un momento...",
        "livechat.textConstants.inputPlaceholderText": "Por favor espere…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "es-PR": {
        "textConstants.lessLinkText": "Menos >>",
        //"textConstants.moreLinkText": "Más",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Hubo un error al procesar su última petición. Por favor intente más tarde.",
        "textConstants.launchPointText": "¿Necesita ayuda?",
        "textConstants.inputboxPlaceholderText": "Escriba el texto aquí",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Asistente virtual inteligente",
        "textConstants.userDisplayName": "Usted: ",
        "textConstants.sendButtonTitleText": "Enviar su pregunta",
        "textConstants.minimizeWindowTitleText": "Cerrar la ventana",
        "textConstants.pleaseWaitText": "Por favor espere…",
        "textConstants.pendingPlaceholder": "Por favor espere…",
        "textConstants.dataCollectionFormatError": "Por favor ingrese su información en el formato correcto.",
        "textConstants.dataCollectionRequiredError" : "Por favor ingrese toda la información obligatoria.",
        "textConstants.dataCollectionRequiredTextDesc": "Información obligatoria",
        "textConstants.linkFoldTitleText": "Ver más enlaces",
        "textConstants.viewPageLinkText": "Ver página",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Su sesión expirará en dos minutos. ¿Desea continuar con su sesión actual?",
        "textConstants.timeoutWarningYesTitle": "Sí",
        "textConstants.skipToContentLinkText": "Saltar al final del chat",
        "textConstants.inputboxErrorText": "Escriba un mensaje para continuar.",
        "textConstants.submitContent": "Enviar",

        "endSession.notificationMessage": "Su sesión finalizó.",

        "accessibility.aria.inputBox": "Pregunta entrada",
        "accessibility.aria.personaLabel": "Asistente Virtual e Inteligente",
        "accessibility.aria.conversationHistoryLabel": "Historial de la conversación",
        "accessibility.aria.toolbar": "Barra de herramientas",
        "accessibility.aria.feedbackOverlay": "Revestimiento de retroalimentación",
        "accessibility.aria.minimize": "Minimizar",
        "accessibility.StepOutTitle": "Esto indica un enlace a un sitio externo que puede no seguir las misma políticas de accesibilidad.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Desconectar chat en vivo",
        "livechat.textConstants.endChatLinkToolTip": "Seleccione para desconectar el chat en vivo",
        // title bar text
        "livechat.textConstants.bannerText": "Charle con nosotros",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Conectando al",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en vivo",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Conectado a la",
        "livechat.textConstants.chatBannerConnectedSecondary": "Operadora del chat en vivo: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "El cliente desconectó el chat en vivo",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "El operador desconectó el chat en vivo",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "El cliente ha finalizado el chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Chat en vivo finalizado",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.errorResponse": "Vaya, parece que no pudimos procesar su solicitud. Inténtelo de nuevo.",
        "livechat.textConstants.pendingPlaceholder": "Por favor espere…",
        "livechat.textConstants.typingNotificationText": "{0} escribiendo...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "¿Está seguro de que desea finalizar su sesión de chat?",
        "textConstants.endChatWarningYesTitle" : "Sí",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} dijo:",
        "livechat.textConstants.sentMessageReceiveText": "Su mensaje fue recibido, el operador le responderá en un momento...",
        "livechat.textConstants.inputPlaceholderText": "Por favor espere…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "es-MX": {
        "textConstants.lessLinkText": "Menos >>",
        //"textConstants.moreLinkText": "Más",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Hubo un error al procesar su última petición. Por favor intente más tarde.",
        "textConstants.launchPointText": "¿Necesita ayuda?",
        "textConstants.inputboxPlaceholderText": "Escriba el texto aquí",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Asistente virtual inteligente",
        "textConstants.userDisplayName": "Usted: ",
        "textConstants.sendButtonTitleText": "Enviar su pregunta",
        "textConstants.minimizeWindowTitleText": "Cerrar la ventana",
        "textConstants.pleaseWaitText": "Por favor espere…",
        "textConstants.pendingPlaceholder": "Por favor espere…",
        "textConstants.dataCollectionFormatError": "Por favor ingrese su información en el formato correcto.",
        "textConstants.dataCollectionRequiredError" : "Por favor ingrese toda la información obligatoria.",
        "textConstants.dataCollectionRequiredTextDesc": "Información obligatoria",
        "textConstants.linkFoldTitleText": "Ver más enlaces",
        "textConstants.viewPageLinkText": "Ver página",
        "textConstants.timeoutWarningNoTitle": "No",
        "textConstants.timeoutWarningText": "Su sesión expirará en dos minutos. ¿Desea continuar con su sesión actual?",
        "textConstants.timeoutWarningYesTitle": "Sí",
        "textConstants.skipToContentLinkText": "Saltar al final del chat",
        "textConstants.inputboxErrorText": "Escriba un mensaje para continuar.",
        "textConstants.submitContent": "Enviar",

        "endSession.notificationMessage": "Su sesión finalizó.",

        "accessibility.aria.inputBox": "Pregunta entrada",
        "accessibility.aria.personaLabel": "Asistente Virtual e Inteligente",
        "accessibility.aria.conversationHistoryLabel": "Historial de la conversación",
        "accessibility.aria.toolbar": "Barra de herramientas",
        "accessibility.aria.feedbackOverlay": "Revestimiento de retroalimentación",
        "accessibility.aria.minimize": "Minimizar",
        "accessibility.StepOutTitle": "Esto indica un enlace a un sitio externo que puede no seguir las misma políticas de accesibilidad.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Desconectar chat en vivo",
        "livechat.textConstants.endChatLinkToolTip": "Seleccione para desconectar el chat en vivo",
        // title bar text
        "livechat.textConstants.bannerText": "Charle con nosotros",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Conectando al",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en vivo",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Conectado a la",
        "livechat.textConstants.chatBannerConnectedSecondary": "Operadora del chat en vivo: {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "El cliente desconectó el chat en vivo",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Regresando a",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "El operador desconectó el chat en vivo",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "El cliente ha finalizado el chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Chat en vivo finalizado",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Volviendo a",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Asistente virtual inteligente",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "El sistema ha finalizado el chat",
        "livechat.textConstants.errorResponse": "Vaya, parece que no pudimos procesar su solicitud. Inténtelo de nuevo.",
        "livechat.textConstants.pendingPlaceholder": "Por favor espere…",
        "livechat.textConstants.typingNotificationText": "{0} escribiendo...",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "¿Está seguro de que desea finalizar su sesión de chat?",
        "textConstants.endChatWarningYesTitle" : "Sí",
        "textConstants.endChatWarningNoTitle" : "No",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} dijo:",
        "livechat.textConstants.sentMessageReceiveText": "Su mensaje fue recibido, el operador le responderá en un momento...",
        "livechat.textConstants.inputPlaceholderText": "Por favor espere…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "fr-CA": {
        "textConstants.lessLinkText": "Moins >>",
        //"textConstants.moreLinkText": "Plus",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "Une erreur est survenue lors du traitement de la dernière demande. Veuillez réessayer plus tard.",
        "textConstants.launchPointText": "Vous avez besoin d’aide ?",
        "textConstants.inputboxPlaceholderText": "Veuillez taper votre texte ici",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "Assistant virtuel intelligent",
        "textConstants.userDisplayName": "Vous : ",
        "textConstants.sendButtonTitleText": "Envoyez votre question.",
        "textConstants.minimizeWindowTitleText": "Fermer la fenêtre de chat",
        "textConstants.pleaseWaitText": "Veuillez patienter…",
        "textConstants.pendingPlaceholder": "Veuillez patienter…",
        "textConstants.dataCollectionFormatError": "Veuillez entrer les renseignements dans le format adéquat.",
        "textConstants.dataCollectionRequiredError" : "Veuillez entrer tous les renseignements requis",
        "textConstants.dataCollectionRequiredTextDesc": "Renseignements requis",
        "textConstants.linkFoldTitleText": "Voir plus de liens",
        "textConstants.viewPageLinkText": "Voir la page",
        "textConstants.timeoutWarningNoTitle": "Non",
        "textConstants.timeoutWarningText": "Votre session expirera fin dans deux minutes. Souhaitez-vous poursuivre votre session actuelle?",
        "textConstants.timeoutWarningYesTitle": "Oui",
        "textConstants.skipToContentLinkText": "Passer à la fin du clavardage",
        "textConstants.inputboxErrorText": "Veuillez taper un message pour continuer.",
        "textConstants.submitContent": "Envoyer",

        "endSession.notificationMessage": "Votre séance est terminée.",

        "accessibility.aria.inputBox": "Question entrée",
        "accessibility.aria.personaLabel": "Assistante virtuelle intelligente",
        "accessibility.aria.conversationHistoryLabel": "Historique de la conversation",
        "accessibility.aria.toolbar": "Barre d’outils",
        "accessibility.aria.feedbackOverlay": "Fenêtre de feed-back superposée",
        "accessibility.aria.minimize": "Réduire",
        "accessibility.StepOutTitle": "Cela indique qu’un lien mène à un site externe qui pourrait ne pas suivre les mêmes politiques d’accessibilité.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "Mettre fin au chat en direct",
        "livechat.textConstants.endChatLinkToolTip": "Cliquez pour mettre fin au chat en direct",
        // title bar text
        "livechat.textConstants.bannerText": "Discutez avec nous",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "Connexion en cours au",
        "livechat.textConstants.chatBannerConnectingSecondary": "Chat en direct",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "Connecté à l’",
        "livechat.textConstants.chatBannerConnectedSecondary": "Opérateur de chat en direct : {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "Retour à",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "Le client a mis fin au chat en direct",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "Retour à",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "L’opérateur a mis fin au chat en direct",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "Le client a mis fin à la discussion par Chat",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "Fin de la séance de clavardage en direct",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "Le système a mis fin à la discussion par Chat",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "Retour à",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "Assistant virtuel intelligent",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "Le système a mis fin à la discussion par Chat",
        "livechat.textConstants.errorResponse": "Il semble que nous n'ayons pas pu traiter votre demande. Veuillez réessayer.",
        "livechat.textConstants.pendingPlaceholder": "Veuillez patienter…",
        "livechat.textConstants.typingNotificationText": "{0} Est en train d’écrire",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "Êtes-vous sûr de vouloir terminer votre session de Chat?",
        "textConstants.endChatWarningYesTitle" : "Oui",
        "textConstants.endChatWarningNoTitle" : "Non",

        // response constants
        "livechat.textConstants.responseTitleText": "{0} a dit :",
        "livechat.textConstants.sentMessageReceiveText": "Message reçu, l’opérateur répond sous peu...",
        "livechat.textConstants.inputPlaceholderText": "Veuillez patienter…",
        "xPosition": 469,
        "yPosition": 519,
    },
    "zh-CN": {
        "textConstants.lessLinkText": "较少的 >>",
        //"textConstants.moreLinkText": "更多",
        "textConstants.almeDisplayName": "IVA: ",
        "textConstants.errorResponse": "处理上一个请求时发生了错误。 请稍后重试。",
        "textConstants.launchPointText": "需要帮助吗？",
        "textConstants.inputboxPlaceholderText": "请在这里输入文本",
        "textConstants.bannerText": "IVA |",
        "textConstants.subBannerText": "智能虚拟助理",
        "textConstants.userDisplayName": "您： ",
        "textConstants.sendButtonTitleText": "提交您的问题。",
        "textConstants.minimizeWindowTitleText": "关闭聊天窗口",
        "textConstants.pleaseWaitText": "请稍候……",
        "textConstants.pendingPlaceholder": "请稍候……",
        "textConstants.dataCollectionFormatError": "请以正确的格式输入信息。",
        "textConstants.dataCollectionRequiredError" : "请输入所有必填信息。",
        "textConstants.dataCollectionRequiredTextDesc": "必填信息",
        "textConstants.linkFoldTitleText": "查看更多链接",
        "textConstants.viewPageLinkText": "查看页面",
        "textConstants.timeoutWarningNoTitle": "否",
        "textConstants.timeoutWarningText": "您的会话将于两分钟后结束。您希望继续当前会话吗？",
        "textConstants.timeoutWarningYesTitle": "是",
        "textConstants.skipToContentLinkText": "跳到对话最后",
        "textConstants.inputboxErrorText": "请输入信息以继续。",
        "textConstants.submitContent": "提交",

        "endSession.notificationMessage": "您的会话已结束。",

        "accessibility.aria.inputBox": "输入问题",
        "accessibility.aria.personaLabel": "智能虚拟助手",
        "accessibility.aria.conversationHistoryLabel": "对话历史记录",
        "accessibility.aria.toolbar": "工具栏",
        "accessibility.aria.feedbackOverlay": "叠加反馈",
        "accessibility.aria.minimize": "最小化",
        "accessibility.StepOutTitle": "这指向一个可能不遵循相同访问政策的外部网站的链接。",

        // end chat link
        "livechat.textConstants.endChatLinkText": "结束在线聊天",
        "livechat.textConstants.endChatLinkToolTip": "点击并结束在线聊天",
        // title bar text
        "livechat.textConstants.bannerText": "在线聊天",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "连接中",
        "livechat.textConstants.chatBannerConnectingSecondary": "在线聊天",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "已连接到",
        "livechat.textConstants.chatBannerConnectedSecondary": "在线聊天接线员： {0}",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "返回至",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "客户已结束在线聊天",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "返回至",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "接线员已结束在线聊天",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "返回到",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "客户结束实时聊天",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "返回到",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "即时聊天结束",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "返回到",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "系统结束实时聊天",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "返回到",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "智能虚拟助理",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "系统结束实时聊天",
        "livechat.textConstants.errorResponse": "看来我们无法处理您的请求。请再尝试一次。",
        "livechat.textConstants.pendingPlaceholder": "请稍候……",
        "livechat.textConstants.typingNotificationText": "{0}",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "您确定要结束实时聊天会话吗?",
        "textConstants.endChatWarningYesTitle" : "是",
        "textConstants.endChatWarningNoTitle" : "否",

        // response constants
        "livechat.textConstants.responseTitleText": "{0}说道：",
        "livechat.textConstants.sentMessageReceiveText": "消息收悉，接线员将很快回复……",
        "livechat.textConstants.inputPlaceholderText": "请稍候……",
        "xPosition": 469,
        "yPosition": 519,
    },
    "ar-SA": {
        "textConstants.lessLinkText": "أقل >>",
        //"textConstants.moreLinkText": "المزيد",
        "textConstants.almeDisplayName": ":ليزا",
        "textConstants.errorResponse": ".حدث خطأ أثناء معالجة آخر طلب. الرجاء إعادة المحاولة في وقت لاحق",
        "textConstants.launchPointText": "هل تحتاج إلى مساعدة؟",
        "textConstants.inputboxPlaceholderText": "الرجاء كتابة النص هنا",
        "textConstants.bannerText": "اسأل ليزا |",
        "textConstants.subBannerText": "المساعدة الذكية الافتراضية",
        "textConstants.userDisplayName": ":أنت",
        "textConstants.sendButtonTitleText": ".قم بإرسال السؤال الخاص بك",
        "textConstants.minimizeWindowTitleText": "إغلاق نافذة الدردشة",
        "textConstants.pleaseWaitText": "الرجاء الانتظار",
        "textConstants.pendingPlaceholder": "الرجاء الانتظار",
        "textConstants.dataCollectionFormatError": ".الرجاء إدخال المعلومات بالتنسيق الصحيح",
        "textConstants.dataCollectionRequiredError" : ".الرجاء إدخال كل المعلومات المطلوبة",
        "textConstants.dataCollectionRequiredTextDesc": "المعلومات المطلوبة",
        "textConstants.linkFoldTitleText": "عرض المزيد من الارتباطات",
        "textConstants.viewPageLinkText": "عرض الصفحة",
        "textConstants.timeoutWarningNoTitle": "لا",
        "textConstants.timeoutWarningText": "سوف تنتهي صلاحية جلستك خلال دقيقتين. هل تريد المتابعة في جلستك الحالية؟",
        "textConstants.timeoutWarningYesTitle": "نعم",
        "textConstants.skipToContentLinkText": "تخطي إلى نهاية المحادثة",
        "textConstants.inputboxErrorText": "يُرجى كتابة رسالة للاستمرار.",
        "textConstants.submitContent": "إرسال",

        "endSession.notificationMessage": "لقد انتهت الجلسة الخاصة بك.",

        "accessibility.aria.inputBox": "إدخال السؤال",
        "accessibility.aria.personaLabel": "المساعد الظاهري الذكي",
        "accessibility.aria.conversationHistoryLabel": "تاريخ المحادثة",
        "accessibility.aria.toolbar": "شريط الأدوات",
        "accessibility.aria.feedbackOverlay": "تراكب التعليقات",
        "accessibility.aria.minimize": "تصغير",
        "accessibility.StepOutTitle": "يشير هذا الأمر إلى رابط يؤدي إلى موقع خارجي قد لا يتبع سياسات إمكانية الوصول نفسها.",

        // end chat link
        "livechat.textConstants.endChatLinkText": "إنهاء الدردشة المباشرة",
        "livechat.textConstants.endChatLinkToolTip": "انقر لإنهاء الدردشة المباشرة",
        // title bar text
        "livechat.textConstants.bannerText": "الدردشة معنا",
        // connecting/disconnecting from chat banners
        "livechat.textConstants.chatBannerConnectingPrimary": "الاتصال بـ",
        "livechat.textConstants.chatBannerConnectingSecondary": "الدردشة المباشرة",
        "livechat.textConstants.chatBannerConnectingAdditional": "",
        "livechat.textConstants.chatBannerConnectedPrimary": "متصل بـ",
        "livechat.textConstants.chatBannerConnectedSecondary": "{0} :" + "مشغل الدردشة المباشرة",
        "livechat.textConstants.chatBannerConnectedAdditional": "",
        "livechat.textConstants.chatBannerUserDisconnectedPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerUserDisconnectedSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerUserDisconnectedAdditional": "أنهى العميل الدردشة المباشرة",
        "livechat.textConstants.chatBannerOperatorDisconnectedPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerOperatorDisconnectedSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerOperatorDisconnectedAdditional": "أنهى المشغل الدردشة المباشرة",
        // live chat foundation
        "livechat.textConstants.chatBannerUserDisconnectPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerUserDisconnectSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerUserDisconnectAdditional": "قد أنهى العميل الدردشة المباشرة",
        "livechat.textConstants.chatBannerOperatorDisconnectPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerOperatorDisconnectSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerOperatorDisconnectAdditional": "انتهت الدردشة المباشرة",
        "livechat.textConstants.chatBannerSystemDisconnectPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerSystemDisconnectSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerSystemDisconnectAdditional": "قد أنهى النظام الدردشة المباشرة",
        "livechat.textConstants.chatBannerNotEngagedDisconnectPrimary": "العودة إلى",
        "livechat.textConstants.chatBannerNotEngagedDisconnectSecondary": "المساعدة الذكية الافتراضية",
        "livechat.textConstants.chatBannerNotEngagedDisconnectAdditional": "قد أنهى النظام الدردشة المباشرة",
        "livechat.textConstants.errorResponse": "عذرا ، يبدو بأننا لم نتمكن على نتيجة، الرجاءحاول مرة أخرى",
        "livechat.textConstants.pendingPlaceholder": "الرجاء الانتظار",
        "livechat.textConstants.typingNotificationText": "{0} يكتب",
        "livechat.textConstants.submitKey": "Enter",

        "textConstants.endChatWarningText" : "هل أنت متأكد على إنهاء دردشة المباشرة الخاصة بك",
        "textConstants.endChatWarningYesTitle" : "نعم",
        "textConstants.endChatWarningNoTitle" : "لا",

        // response constants
        "livechat.textConstants.responseTitleText": ":{0}" + "قال",
        "livechat.textConstants.sentMessageReceiveText": "تم تلقي الرسالة، سيرد المشغل خلال فترة وجيزة",
        "livechat.textConstants.inputPlaceholderText": "الرجاء الانتظار",
        
        "xPosition": window.innerWidth,
        "yPosition": 519,
    },
};

export {
    languageSpecificSettingOverrides
};


// WEBPACK FOOTER //
// ./settings/language-specific-setting-override.ts